import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {bigWinEvents} from "../../views/WinTextView";
import {ForegroundAnimation} from "../../foregroundanimation/ForegroundAnimation";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {BetLineEvents} from "../../betline/ImmortalFruitsBetlinesView";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ImmortalFruitsParsedGameData} from "../../server/data/ImmortalFruitsParsedGameData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ImmortalFruitsGameConfig} from "../../ImmortalFruitsGameConfig";

export class ImmortalIdleAnimationController implements GameRoundPresentation {
    private _tl: TimelineLite;
    private  _totalWin:number;

    /**
     * @constructs
     */
    constructor() {
        this.addEventListeners();
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedServerData): gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax | null {
        this._tl = new TimelineLite();
        //this._tl.add(() => this.playIdle());
        const delay: number = MathHelper.randomIntInRange(3.5, 4);
        const timeLBet =2;
        const jackpotAnimPos =3;
        const posDel =13;
        // this._tl = new TimelineLite({
        //     onComplete: () => this.playIdle()
        // });

        this._tl.add(() => EventHandler.dispatchEvent(new GameEvent(bigWinEvents.PLAY_GREENLIGHTS, "reset")), 0);
        this._tl.add(() => EventHandler.dispatchEvent(new GameEvent(bigWinEvents.PLAY_GREENLIGHTS, "logo")), delay);
        this._tl.add(() => EventHandler.dispatchEvent(new GameEvent(bigWinEvents.PLAY_GREENLIGHTS, "loop1")), delay + 0.8);
        this._tl.add(() => {
            if(!(this._totalWin>0)){
                EventHandler.dispatchEvent(new GameEvent(BetLineEvents.SHOW_BETLINE_NUM));
            }
        },delay+timeLBet);
        this._tl.add(() => {
            if(!(this._totalWin>0)) {
                EventHandler.dispatchEvent(new GameEvent(BetLineEvents.SHOW_JACKPOT_ANIM));
            }
        },delay+jackpotAnimPos);
        this._tl.add(() => {

        },delay+posDel);
        /*this delay is to let idle animation complete*/
        return this._tl;
    }
    private onGameDataParsed(data:ImmortalFruitsParsedGameData){
        this._totalWin = data.totalWin;
    }
    /**
     * @description To register events.
     */
    private addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, BalanceEvent.BET, () => {
            this._tl?.kill();
            EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_GREENLIGHTS));
            ForegroundAnimation.resetStaticBgShow();
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvents.KILL_ANIMATIONS));
        });
    }
}